module.exports = __webpack_public_path__ + "static/img/codingRulesManage.f03f3e30.png";